import { assign, createMachine } from "xstate";
import { IOfferMode } from "@nju/data-access-portal-offers";
import { cancelOrder } from "@nju/data-access-portal-order";
import { generalErrorMessage } from "@nju/utils";

interface IContext {
  orchestratorId: string;
  error?: string;
  mode: IOfferMode;
  skipCancellation: boolean;
}

type IEvent =
  | { type: "SUBMIT" }
  | { type: "CANCEL_SUCCESS" }
  | { type: "CANCEL_ERROR" };

export const cancelOrderMachine = createMachine(
  {
    schema: {
      context: {} as IContext,
      events: {} as IEvent,
    },
    context: {
      orchestratorId: "",
      error: undefined,
      mode: "ftth",
      skipCancellation: false,
    },
    initial: "ready",
    states: {
      ready: {
        on: {
          SUBMIT: {
            actions: "clearRequestError",
            target: "validate",
          },
        },
      },
      validate: {
        always: [
          {
            cond: "skipCancellation",
            actions: "cancelOrderSuccess",
            target: "final",
          },
          {
            target: "send",
          },
        ],
      },
      send: {
        invoke: {
          src: "cancelOrder",
        },
        on: {
          CANCEL_SUCCESS: {
            actions: "cancelOrderSuccess",
            target: "final",
          },
          CANCEL_ERROR: {
            actions: "setRequestError",
            target: "ready",
          },
        },
      },
      final: {
        type: "final",
      },
    },
  },
  {
    guards: {
      skipCancellation: ({ skipCancellation }) => {
        return skipCancellation;
      },
    },
    actions: {
      setRequestError: assign((_, __: IEvent) => {
        return {
          error: generalErrorMessage,
        };
      }),
      clearRequestError: assign((_, __: IEvent) => {
        return {
          error: undefined,
        };
      }),
    },
    services: {
      cancelOrder: ({ orchestratorId, mode }) => {
        return async (callback) => {
          try {
            (
              await cancelOrder({
                reason: "agentRequest",
                orchestratorId,
                mode: mode === "mobile" ? "multiOrder" : mode,
              })
            ).unwrap();

            callback({ type: "CANCEL_SUCCESS" });
          } catch {
            callback({ type: "CANCEL_ERROR" });
          }
        };
      },
    },
  },
);
